import type { AudienceSegmentSearchInputDescriptor } from '@openx/types/gqlTypes';
import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext';

export const useAudienceSearchFetch = (input: AudienceSegmentSearchInputDescriptor) => {
  const { useDealPromptAudienceSearchFetch } = useDealPromptDomainsContext();

  const { fetchDealPromptAudienceSearch } = useDealPromptAudienceSearchFetch(input);

  return fetchDealPromptAudienceSearch;
};
